import useCheckPC from "@repo/hooks/utils/useCheckPC";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Button from "@components/atoms/Button";
import Icon from "@components/atoms/Icon";

import useCart from "@hooks/reducerHooks/useCart";
import useLayout from "@hooks/reducerHooks/useLayout";
import useUser from "@hooks/reducerHooks/useUser";

import { IconName } from "@const/enum";
import { URLS } from "@const/urls";

function RightMenu({ isSaleShutDown }: { isSaleShutDown: boolean }) {
  const navigate = useNavigate();
  const location = useLocation();

  const { isPC } = useCheckPC();
  const { isHeaderOpen, openLoginModal, openCart, openSearch } = useLayout();
  const { accessToken } = useUser();
  const { cart } = useCart();

  return (
    <>
      {isPC ? (
        accessToken && (
          <ul className="flex items-center justify-end gap-3">
            <li>
              <Button onClick={openSearch} variant="icon">
                <Icon alt="Search" height="20px" name={IconName.Search_700} width="20px" />
              </Button>
            </li>
            <li>
              <Button
                onClick={() => {
                  accessToken
                    ? navigate(URLS.ACCOUNT_ORDER_HISTORY)
                    : openLoginModal({ redirectUrl: location.pathname });
                }}
                variant="icon"
              >
                <Icon alt="Account" height="20px" name={IconName.Person_700} width="20px" />
              </Button>
            </li>
            <li className="relative">
              <Button disabled={isSaleShutDown} onClick={openCart} variant="icon">
                <Icon alt="Cart" height="20px" name={IconName.ShoppingBag_700} width="20px" />
              </Button>
              {cart && cart.totalQuantity > 0 ? (
                <span className="bg-blue absolute -top-1 -right-1.5 flex size-[16px] cursor-pointer items-center justify-center rounded-[8px] p-px text-[10px] text-white">
                  {cart.totalQuantity}
                </span>
              ) : null}
            </li>
          </ul>
        )
      ) : (
        <>
          {!isHeaderOpen && accessToken ? (
            <ul className="flex items-center justify-end gap-4">
              <li className="relative">
                <Button
                  onClick={() => {
                    accessToken
                      ? navigate(URLS.ACCOUNT_ORDER_HISTORY)
                      : openLoginModal({ redirectUrl: location.pathname });
                  }}
                  variant="icon"
                >
                  <Icon alt="Cart" height="1.5rem" name={IconName.Person_700} width="1.5rem" />
                </Button>
              </li>
              <li className="relative">
                <Button disabled={isSaleShutDown} onClick={openCart} variant="icon">
                  <Icon alt="Cart" height="1.5rem" name={IconName.ShoppingBag_700} width="1.5rem" />
                </Button>
                {cart && cart.totalQuantity > 0 ? (
                  <span className="bg-blue absolute -top-1 -right-1.5 flex size-[16px] cursor-pointer items-center justify-center rounded-[8px] p-px text-[10px] text-white">
                    {cart.totalQuantity}
                  </span>
                ) : null}
              </li>
            </ul>
          ) : null}
        </>
      )}
    </>
  );
}

export default RightMenu;
